module.exports = __webpack_public_path__ + "static/media/amy_wright.6ac9978d.png";